import moment from 'moment'
import ruiTool from './ruiTool';

moment.locale('zh-cn')

//yyyy-MM-DD HH:mm:ss
//dd 星期几
let ruiDate = {

   // 获取当前时间
   getNowTime() {
      return new Date();
   },
   // 获取当前时间
   getNow() {
      return moment().format("YYYY-MM-DD HH:mm:ss");
   },

   // 返回日期范围展示
   toRangeDate(start, end) {
      if (ruiTool.isNull(end))
         return '';
      if (ruiTool.isNull(end))
         return '';
      return moment(start).format('yyyy-MM-DD') + "~" + moment(end).format('yyyy-MM-DD')
   },
   // 短日期展示
   toShortDate(val) {
      if (val == undefined)
         return '';
      return moment(val).format('yyyy-MM-DD')
   },
   // 长日期展示
   toLongDate(val) {
      if (val == undefined)
         return '';
      return moment(val).format('yyyy-MM-DD HH:mm:ss')
   },
   // 自定义格式化
   toFormatDate(val, format) {
      if (val == undefined)
         return '';
      return moment(val).format(format)
   },
   // 计算两个时间相差的分钟数
   getDiffMinute(startTime, endTime) {
      let value = moment(startTime).diff(endTime, 'minutes');
      return value;
   },
   // 计算两个时间相差的秒数
   getDiffSecond(startTime, endTime) {
      let value = moment(startTime).diff(endTime, 'seconds');
      return value;
   },
   // 比较，start<end 返回-1 start>end 返回1 , 相同返回0
   compare(start, end) {
      start = this.toLongDate(start)
      end = this.toLongDate(end)
      let value = moment(start).diff(end, 'minutes');
      if (value < 0)
         return -1;
      if (value > 0)
         return 1;
      if (value = 0)
         return 0
   }
}

export default ruiDate
